import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayers = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 16.5L12 21.75L21 16.5M3 12L12 17.25L21 12M3 7.5L12 12.75L21 7.5L12 2.25L3 7.5Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLayers;
